import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { inventoryItemSchema, InventoryItem } from "../types/inventory";
import { Form } from "../../../components/ui/form";
import { Button } from "../../../components/ui/button";
import { BasicInfoSection } from "./form-sections/BasicInfoSection";
import { StockAlertSection } from "./form-sections/StockAlertSection";
import { AdditionalDetailsSection } from "./form-sections/AdditionalDetailsSection";

interface ItemFormProps {
  defaultValues?: Partial<InventoryItem>;
  onSubmit: (data: any) => void;
  onCancel: () => void;
  submitLabel?: string;
}

export function ItemForm({ defaultValues, onSubmit, onCancel, submitLabel = "Save Changes" }: ItemFormProps) {
  const form = useForm({
    resolver: zodResolver(inventoryItemSchema),
    defaultValues: defaultValues || {
      name: '',
      category: '',
      quantity: 0,
      unit: '',
      minThreshold: 0,
      minExpirationThreshold: 0,
      reorderQuantity: 0,
      batchNumber: '',
      expirationDate: undefined,
      supplier: '',
      notes: '',
      location: '',
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <div className="space-y-8 max-h-[80vh] overflow-y-auto pr-6 pb-4 scrollbar-thin [scrollbar-width:thin] [scrollbar-color:hsl(var(--muted-foreground)/0.3)_transparent]">
          <BasicInfoSection form={form} />
          <StockAlertSection form={form} />
          <AdditionalDetailsSection form={form} />
        </div>
        <div className="flex justify-end gap-3 py-4 border-t bg-background">
          <Button 
            type="button" 
            variant="outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button type="submit">{submitLabel}</Button>
        </div>
      </form>
    </Form>
  );
}
